import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FieldsContainer,
  UploadCsvOption,
} from "../../constants/assets/containers";
import { getBulkCities, getCity, getCityList } from "../../store/actions/City";
import { getDriverCategoryList } from "../../store/actions/DriverCategory";
import {
  getBulkLocalities,
  getLocality,
  getLocalityList,
} from "../../store/actions/Locality";
import Upload from "sushiweb/Icons/all/Upload";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FileUpload from "../Common/FileUpload";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import variables from "../../constants/assets/variables";
import { Link } from "../../constants/assets/containers";
import {
  bulkUploadDriverIds,
  launchAppRelease,
} from "../../store/actions/DriverAppReleases";
import { useHistory } from "react-router-dom";

const ReleaseLaunchDetails = ({
  getCity,
  getCityList,
  getLocality,
  getLocalityList,
  cityList,
  localityList,
  nextPageCity,
  nextPageLocality,
  appReleaseId,
  appReleaseVersion,
  setCreationId,
  setCreationVersion,
  bulkUploadDriverIds,
  launchAppRelease,
  launchState,
  setLaunchState,
  activeFile,
  setActiveFile,
}) => {
  const history = useHistory();
  const [priorityFlag, setPriorityFlag] = useState(false);
  const [callbackKey, setCallbackKey] = useState("");
  const [fileUploadUrl, setFileUploadUrl] = useState("");

  const sampleCsvUrl = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_driver_id_app_launch.csv`
      : ""
  }`;

  const handleChange = (key, val) => {
    const values = { ...launchState };
    values[key] = val;
    if (key == "city_ids") {
      setPriorityFlag(true);
      values["locality_ids"] = [];
    }
    setLaunchState(values);
  };

  const handleFileChange = (file) => {
    setActiveFile(file);
  };

  const handleLaunchSuccess = () => {
    const appId = appReleaseId;
    const appVersion = appReleaseVersion;
    setCreationId("");
    setCreationVersion("");
    history.push(
      `/driver-app-releases/actions?type=edit&id=${appId}&version=${appVersion}`
    );
  };

  const handleFileUploadSuccess = () => {
    launchAppRelease(appReleaseId, {
      ...launchState,
      callback_key: callbackKey,
    }).then((_) => {
      handleLaunchSuccess();
    });
  };

  useEffect(() => {
    if (appReleaseId) {
      if (activeFile) {
        bulkUploadDriverIds({
          filename: activeFile.name,
          expected_app_version: appReleaseVersion,
        }).then((res) => {
          if (res) {
            setFileUploadUrl(res.file_upload_url);
            setCallbackKey(res.callback_key);
          }
        });
      } else {
        launchAppRelease(appReleaseId, launchState).then((_) => {
          handleLaunchSuccess();
        });
      }
    }
  }, [appReleaseId, activeFile]);

  return (
    <ReleaseLaunchDetailsContainer className="mt-40">
      <FieldsContainer border noPadding>
        <InfiniteScrollDropdown
          id="cityDropdownAppRelease"
          multiple
          priorityFlag={true}
          appliedFilters={{}}
          getActiveList={getCityList}
          nextPage={nextPageCity}
          resKey="cities"
          modalState={"Edit"}
          keyName="city_ids"
          labelKey="city_name"
          getDataLabelKey="city.city_name"
          keyTypeToSet="id"
          label="Cities"
          handleChange={handleChange}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          getActiveItemById={getCity}
        />
        <InfiniteScrollDropdown
          id="localityDropdownAppRelease"
          multiple
          setPriorityFlag={setPriorityFlag}
          priorityFlag={priorityFlag}
          appliedFilters={
            launchState.city_ids ? { city_id: launchState.city_ids } : {}
          }
          getActiveList={getLocalityList}
          nextPage={nextPageLocality}
          resKey="localities"
          modalState={"Edit"}
          keyName="locality_ids"
          labelKey="locality_name"
          labels={["locality_name", "id"]}
          getDataLabelKey="locality.locality_name"
          keyTypeToSet="id"
          getActiveItemById={getLocality}
          label="Localities"
          handleChange={handleChange}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
        />
        <InfiniteScrollDropdown
          id="category_dropdown"
          multiple
          priorityFlag={true}
          appliedFilters={{}}
          getActiveList={getDriverCategoryList}
          resKey="driverCategories"
          modalState={"Edit"}
          keyName="categories"
          labelKey="name"
          getDataLabelKey="driverCategories.name"
          keyTypeToSet="category"
          label="Launch Categories (Default selection is all, select to override)"
          handleChange={handleChange}
        />
        <FileUpload
          heading="Bulk upload rider FE Ids"
          activeFile={activeFile}
          setActiveFile={handleFileChange}
          UploadIcon={<Upload color={variables.black} />}
          handleFileUploadSuccess={handleFileUploadSuccess}
          noAckCall
          callback_key={callbackKey}
          presign_url={fileUploadUrl}
        />
        <div className="flex items-center download-link mt-20">
          <Link target="_blank" download href={sampleCsvUrl}>
            Download sample csv
          </Link>
        </div>
      </FieldsContainer>
    </ReleaseLaunchDetailsContainer>
  );
};

const ReleaseLaunchDetailsContainer = styled.div`
  & > div {
    padding: 30px;
  }
  .MuiAutocomplete-root {
    width: 70% !important;
  }
  .download-link {
    a {
      color: ${variables.blue500};
      font-size: 0.875rem;
    }
  }
`;

function mapStateToProps(state) {
  const { City, Locality } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLocalityList: bindActionCreators(getLocalityList, dispatch),
    getCity: bindActionCreators(getBulkCities, dispatch),
    getLocality: bindActionCreators(getBulkLocalities, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
    getDriverCategoryList: bindActionCreators(getDriverCategoryList, dispatch),
    bulkUploadDriverIds: bindActionCreators(bulkUploadDriverIds, dispatch),
    launchAppRelease: bindActionCreators(launchAppRelease, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReleaseLaunchDetails);
